export const CONTACT_LINKS = {
  dmUrl: 'https://www.instagram.com/',
  supportEmail: 'support@veeflix.in',
};

export const getSupportMailto = () => `mailto:${CONTACT_LINKS.supportEmail}`;
